import { createLog, debugEnabled } from './utils/logger'

const log = createLog()

const onContentLoaded = handler => {
  if (['complete', 'loaded', 'interactive'].includes(document.readyState)) {
    handler()
  } else {
    document.addEventListener('DOMContentLoaded', handler)
  }
}

export default async function loadStorage (broker, brokerId, scriptBase) {
  return new Promise((resolve, reject) => {
    const path = `${scriptBase}/storage/index.html`
    const srcPath = debugEnabled ? `${path}?adsDebug=tcfv2` : path
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.title = 'TCFV2 Storage'
    iframe.src = `${srcPath}#brokerId=${brokerId}`

    const onLoad = async () => {
      log('loaded')
      const { contentWindow } = iframe

      iframe.removeEventListener('load', onLoad)

      if (!contentWindow) {
        reject(new Error('Couldn\'t successfully create CMP'))
      }
    }

    iframe.addEventListener('load', onLoad)
    iframe.addEventListener('error', reject)

    broker.on('storageLoaded', data => {
      log('storage', data)
      if (!data.canStoreUserPreference) {
        const parent = iframe.parentNode
        if (parent) {
          log('unloading iframe')
          parent.removeChild(iframe)
        }
        resolve({ tcData: data.tcData })
        return
      }
      resolve({ iframe, tcData: data.tcData })
    })

    onContentLoaded(() => document.body.appendChild(iframe))
  })
}
